import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import {BrowserRouter, useLocation, useNavigate} from 'react-router-dom';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import store from './store';
import Layouts from './layouts';
import { REACT_APP_GOOGLE_MAPS_API_KEY, THEME_CONFIG } from './configs/AppConfig';
import './lang';
import ErrorBoundary from "./views/app-views/components/ErrorBoundaryComponent";
import { LoadScript } from "@react-google-maps/api";
import LoadingComponent from "./views/app-views/components/LoadingComponent";
import {getUser} from "./services/CookieService";
import {saveCurrentUserData} from "./serviceHandler/user/UserServiceHandler";

const libraries = ["places"];

const themes = {
    dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
    light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
    return (
        <>
            <Provider store={store}>
                <BrowserRouter future={{
                    v7_relativeSplatPath: true,
                    v7_startTransition: true
                }}>
                    <ErrorBoundary>
                        <LoadScript
                            googleMapsApiKey={`${REACT_APP_GOOGLE_MAPS_API_KEY}&loading=async`}
                            loadingElement={<LoadingComponent />}
                            libraries={libraries}
                        >
                            <ThemeSwitcherProvider
                                themeMap={themes}
                                defaultTheme={THEME_CONFIG.currentTheme}
                                insertionPoint="styles-insertion-point"
                            >
                                <LocationWatcher />
                            </ThemeSwitcherProvider>
                        </LoadScript>
                    </ErrorBoundary>
                </BrowserRouter>
            </Provider>
        </>
    );
}

function LocationWatcher() {

    const location = useLocation();
    const navigator = useNavigate();

    useEffect(() => {
        const newFull = location.pathname + location.search;
        const currentFull = sessionStorage.getItem('currentFullPath') || '';

        if(getUser()) {
            saveCurrentUserData(true, navigator, newFull)
        }

        const prevPathname = sessionStorage.getItem('currentPathname');
        if (prevPathname !== location.pathname) {
            sessionStorage.setItem('prevFullPath', currentFull);
        }

        sessionStorage.setItem('currentFullPath', newFull);
        sessionStorage.setItem('currentPathname', location.pathname);

        // eslint-disable-next-line
    }, [location]);

    return <Layouts />;
}

export default App;
